import { LegalCodes } from '@goodrx/heydoctor-core';

export const LegalCodesToDisplayName = {
  [LegalCodes.PrivacyPolicy]: 'Privacy Policy',
  [LegalCodes.TermsAndConditions]: 'Terms of Use',
  [LegalCodes.NoticeOfPrivacyPractices]: 'Notice of Privacy Practices',
  [LegalCodes.ConsentToTelemedicine]: 'Informed Consent for Telehealth Services',
  [LegalCodes.AgreementForSelfPaymentOfServices]: 'Agreement for Self-Payment of Services',
};

export const Statuses = {
  // Tasks
  Open: 'open',
  Uploaded: 'uploaded',
  Rejected: 'rejected',
  Approved: 'approved',
  Complete: 'complete',

  // Visits
  PreVisitIntake: 'pre_visit_intake',
  ReadyForProvider: 'ready_for_provider',
  Cancelled: 'cancelled',
  SignedAndClosed: 'signed_and_closed',
  Abandoned: 'abandoned',
};

export const CompletedStatuses = [
  Statuses.ReadyForProvider,
  Statuses.Cancelled,
  Statuses.SignedAndClosed,
  Statuses.Abandoned,
];

export const Breakpoints = {
  sm: 600,
  md: 900,
  lg: 1200,
  xl: 1500,
};

export const ServiceCategories = {
  Elective: 'Elective',
  Prevention: 'Prevention',
  PrimaryCare: 'Primary Care',
  Screening: 'Screening',
  Testing: 'Testing',
  UrgentCare: 'Urgent Care',
};

export const documentTitles = {
  Account: 'Account',
  ConfirmAddress: 'Confirm Address',
  ForgotPassword: 'Forgot Password',
  AllServices: 'All Services',
  PatientSetup: 'Patient Setup',
  ResetPassword: 'Reset Password',
  SignIn: 'Sign In',
  SignUp: 'Sign Up',
  StartAVisit: 'Start A Visit',
  VerifyEmail: 'Verify Email',
  VisitSummary: 'Visit Summary',
  VideoChat: 'Video Chat',
};

export const GOODRX_SUPPORT_PHONE_NUMBER = '(855) 918-0927';
export const HEYDOCTOR_SUPPORT_PHONE_NUMBER = '(415) 237-1378';

export const NotificationStatuses = {
  ENABLED: 'enabled',
  DISABLED: 'disabled',
  BLACKLISTED: 'blacklisted',
};

export const NotificationTopics = {
  NEW_MESSAGES: 'new_messages',
};

export const NotificationChannels = {
  SMS: 'sms',
  PUSH: 'push',
  EMAIL: 'email',
  IN_APP: 'in_app',
};

export const VideoSessionStatuses = {
  CLOSED: 'closed',
  OPEN: 'open',
  NOTIFY: 'notify',
  WAITING: 'waiting',
  ACTIVE: 'active',
  REVIEW: 'review',
  REJECTED: 'rejected',
  APPROVED: 'approved',
};

export const SocialMediaPlatforms = [
  {
    title: 'Twitter',
    link: 'https://twitter.com/heydoctorco',
    icon: 'twitter',
  },
  {
    title: 'Facebook',
    link: 'https://business.facebook.com/heydoctor.co/',
    icon: 'facebook',
  },
  {
    title: 'Instagram',
    link: 'https://www.instagram.com/heydoctor_by_goodrx/',
    icon: 'instagram',
  },
];

export const CookieUniqueId = {
  GRX: 'grx_unique_id',
};
